import { Hero } from "@/components/Hero";
import { FundingProgress } from "@/components/FundingProgress";
import { Mission } from "@/components/Mission";
import { Timeline } from "@/components/Timeline";
import { ParallelNarratives } from "@/components/ParallelNarratives";
import { Documentary } from "@/components/Documentary";
import { Fundraising } from "@/components/Fundraising";
import { Book } from "@/components/Book";
import { Blog } from "@/components/Blog";
import { CommunityStories } from "@/components/CommunityStories";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <FundingProgress />
      <Mission />
      <Documentary />
      <Timeline />
      <ParallelNarratives />
      <CommunityStories />
      <Fundraising />
      <Book />
      <Blog />
    </div>
  );
};

export default Index;